import React from 'react'

export const CalculatedDataContext = React.createContext()
export const AllInputDataContext = React.createContext()
export const SliderValuesContext = React.createContext()
export const SetSliderValuesContext = React.createContext()
export const UserLinkContext = React.createContext()
export const ResetSlidersContext = React.createContext()
